import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './meeting-templates.types';
import * as constants from './meeting-templates.constants';

export const storeMeetingTemplate = generateStoreResourceAction<types.IMeetingTemplate>(
  constants.STORE_MEETING_TEMPLATE,
);
export const clearMeetingTemplate = generateClearResourceAction(constants.CLEAR_MEETING_TEMPLATE);
